import {Component, EventEmitter, Inject, Input, Output} from "@angular/core";
import {MAT_BOTTOM_SHEET_DATA} from "@angular/material/bottom-sheet";

@Component({
    selector: 'app-errors',
    templateUrl: './errors.component.html'
})
export class ErrorsComponent {

    @Input() error: boolean;
    @Input() errorHeader: string;
    @Input() errorMessage: string;
    @Input() errorResponseCode: number = 0;
    @Input() showContactInfo = true;
    @Input() isInvalidPassword: boolean = false;
    @Input() showPhone: boolean  = false;

    @Output() showLoginEvent: EventEmitter<any> = new EventEmitter();
}
